/**
 * Created by Jerker Nord on 2024-01-08.
 */
import {LonerDuckSymbol} from "./symbols/LonerDuckSymbol";
import {Loner} from "../../../Loner";
import {gsap} from "gsap";
import {SYMBOL_NAMES} from "../../../../core/reel/ReelInterfaces";
import {LonerDuckMX2Symbol} from "./symbols/LonerDuckMX2Symbol";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {LonerDuckMX1Symbol} from "./symbols/LonerDuckMX1Symbol";
import {LonerDuckMaxWinSymbol} from "./symbols/LonerDuckMaxWinSymbol";
import {LonerGameAssets} from "../../../LonerGameAssets";
import {LonerDuckClipSymbol} from "./symbols/LonerDuckClipSymbol";
import {LonerSound} from "../../../sound/LonerSound";

export class LonerDuckAnimator extends PIXI.Container {

    public static DIRECTION_RIGHT:string = "_right";
    public static DIRECTION_LEFT:string = "_left";
    public static DUCK_BASE_PATH:string = "duck_syms/";

    protected SPACE_BETWEEN_DUCKS:number = 110;
    protected DUCK_STEP_ANIMATION_DURATION:number = 2.5;
    protected DUCKS_Y_POS:number = 0;
    protected DUCKS_X_START_POS:number = -250;
    protected DUCK_WIDTH:number = 165;
    protected DUCK_INIT_REEL:number;
    protected DUCK_INIT_ROW:number;
    protected BULLET_HOLE_POSITIONS:PIXI.Point[] = [new PIXI.Point(-200,-10), new PIXI.Point(100, -10)];
    protected _ducks:LonerDuckSymbol[];
    protected _background:PIXI.Sprite;
    protected _direction:string;
    protected _duckMoveAmount:number;
    protected _ducksContainer:PIXI.Container;
    protected _nextDuck:LonerDuckSymbol;
    protected _animationStepsCounter:number;
    protected _moveDucksTL:gsap.core.Timeline;
    protected _allMX2Ducks:LonerDuckMX2Symbol[];
    protected _hasMX2Duck:boolean;
    protected _mx2InfoUpdated:boolean = false;
    protected _bulletHoles:PIXI.Sprite[];
    protected _isPaused:boolean;

    constructor() {
        super();
        this._direction = LonerDuckAnimator.DIRECTION_LEFT;
    }

    protected init():void {
        this.initBackground();

        this.initBulletHoles();

        this._ducksContainer = new PIXI.Container();
        this.addChild(this._ducksContainer);
    }

    protected initBulletHoles():void{
        this._bulletHoles = [];
        for (let i:number=0;i<this.BULLET_HOLE_POSITIONS.length;i++){
            const bulletHole:PIXI.Sprite = new PIXI.Sprite(PIXI.Texture.EMPTY);
            bulletHole.anchor.set(0.5, 0.5);
            bulletHole.position = this.BULLET_HOLE_POSITIONS[i];
            bulletHole.visible = false;
            this._bulletHoles.push(bulletHole);
            this.addChild(bulletHole);
        }
    }

    public initDucks(ducks:string[], duckValues:number[]):void {
        this._animationStepsCounter = 0;
        this._ducks = [];
        for(let i:number = 0; i < ducks.length; i++) {

            if(ducks[i] == "X") {
                ducks[i] = LonerGameAssets.SSD_EXPLODED_DUCKS[MathHelper.randomIntInRange(0, LonerGameAssets.SSD_EXPLODED_DUCKS.length - 1)];
                this._nextDuck = Loner.duckSymbolPool.getSymbol(ducks[i], LonerDuckAnimator.DUCK_BASE_PATH +
                    Loner.ssdMainView.getDuckValuePath(duckValues[i], ducks[i]) +
                    ducks[i] + this._direction, duckValues[i]);
                this._nextDuck.isShot = true;
            }else{
                this._nextDuck = Loner.duckSymbolPool.getSymbol(ducks[i], LonerDuckAnimator.DUCK_BASE_PATH +
                    Loner.ssdMainView.getDuckValuePath(duckValues[i], ducks[i]) +
                    ducks[i] + this._direction, duckValues[i]);
            }

            this._nextDuck.direction = this._direction;
            this._nextDuck.reel = this.DUCK_INIT_REEL;
            this._nextDuck.row = this.DUCK_INIT_ROW;
            this._nextDuck.setMultiplier(duckValues[i]);
            this._ducks.push(this._nextDuck);
        }
        this.addNextDuck();
        this.placeDucks();
    }

    protected addNextDuck():void {
        //Override
    }

    public shootDuck(duckPosition:number, symbolName:string):void {
        if(this._ducks[duckPosition].symbolName == symbolName) {
            if(this._ducks[duckPosition].symbolName == "MX1") {
                (<LonerDuckMX1Symbol>this._ducks[duckPosition]).getSymbolShotTL();
            } else {
                this._ducks[duckPosition].getSymbolShotTL();
            }
        } else {
            //console.log("ERROR! Duck shot is " + this._ducks[duckPosition].symbolName + " but should be " + symbolName);
            //debugger;
        }
    }

    public missDuck(missPosition:number, missTexture:string):void{
        if (this._bulletHoles[missPosition].visible == false){
            this._bulletHoles[missPosition].texture = Loner.assetLoader.getTextures(missTexture)[0];
            this._bulletHoles[missPosition].visible = true;
        }
    }

    public getMoveAllDucksTL():gsap.core.Timeline {
        const reels:string[][]=Loner.model.isRestore ?Loner.model.initData.reels:Loner.model.gameData.reels;
        if(this._moveDucksTL) {
            this._moveDucksTL.kill();
        }
        this._duckMoveAmount = this._ducksContainer.position.x - (this.SPACE_BETWEEN_DUCKS + this.DUCK_WIDTH);
        this._moveDucksTL = gsap.timeline({
            onUpdate : () => this.onMoveDucksTLUpdate(),
            onComplete : () => this.onMoveAllDucksComplete(),
            paused : this._isPaused
        });
        this._moveDucksTL.add(() => {
            this._hasMX2Duck = false;
            for(let i:number = 0; i < this._ducks.length; i++) {
                if(this._ducks[i].symbolName == SYMBOL_NAMES.MX2) {
                    (<LonerDuckMX2Symbol>this._ducks[i]).movingDuck();
                    this._hasMX2Duck = true;
                } else {
                    this._ducks[i].movingDuck();
                }
            }
        });
        this._moveDucksTL.add(gsap.to(this._ducksContainer.position, {
            ease : "none",
            duration : this.DUCK_STEP_ANIMATION_DURATION,
            x : this._duckMoveAmount
        }));
        if(reels && reels.length>0 && reels[0].length>0 && (reels[reels.length-1][0]==="MAX" || reels[reels.length-1][2]==="MAX" || reels[0][1]==="MAX")){
            this._moveDucksTL.add(()=>{
                if(!Loner.soundPlayer.player.fetchSoundPlayer(LonerSound.SSD_MAX_SYM_PASSING_BY)?.isPlaying){
                    Loner.soundPlayer.playSound(LonerSound.SSD_MAX_SYM_PASSING_BY);
                    Loner.soundPlayer.fadeMusic(1,0.5,0.1);
                }
            },this.DUCK_STEP_ANIMATION_DURATION/2);
        }
        if(reels && reels.length>0 && reels[0].length>0 && (reels[0][0]==="MAX" || reels[3][1]==="MAX" || reels[0][2]==="MAX")){
            this._moveDucksTL.add(()=>{
               Loner.soundPlayer.fadeMusic(0.5,1,0.1);
            },0);
        }

        return this._moveDucksTL;
    }

    protected onMoveDucksTLUpdate():void {
        this._moveDucksTL.timeScale(Loner.ssdMainView.getTimescale());

        if(this._mx2InfoUpdated == false && (this._moveDucksTL.totalDuration() - this._moveDucksTL.time()) < 0.5) {
            this._mx2InfoUpdated = true;
            this._allMX2Ducks = [];

            if(this._hasMX2Duck == true) {
                this._hasMX2Duck = false;
                for(let i:number = 0; i < this._ducks.length; i++) {
                    if(this._ducks[i].symbolName == SYMBOL_NAMES.MX2 && this._ducks[i].isShot == false) {
                        this._allMX2Ducks.push((<LonerDuckMX2Symbol>this._ducks[i]));
                    }
                }
            }
            Loner.ssdMainView.doMX2Update(this._allMX2Ducks, this.DUCK_INIT_ROW);
        }
    }

    protected onMoveAllDucksComplete():void {
        //Override
    }

    protected placeDucks():void {
        let duckXPos:number = this.DUCKS_X_START_POS;
        this._ducksContainer.position.y = this.DUCKS_Y_POS;
        for(let i:number = 0; i < this._ducks.length; i++) {
            if(i > 0) {
                duckXPos += this.DUCK_WIDTH + this.SPACE_BETWEEN_DUCKS;
            }
            this._ducks[i].position.x = duckXPos;
            if(this._ducks[i].row == 1) {
                this._ducks[i].reel = i;
            } else {
                this._ducks[i].reel = i + 1;
            }
            this._ducksContainer.addChild(this._ducks[i]);
        }
    }

    protected initBackground():void {
        //Override
    }

    public pauseDuckAnimation():void{
        this._isPaused = true;
    }

    public resumeDuckAnimation():void {
        this._isPaused = false;
        this.startNewDuckMoveCycle();
    }

    protected startNewDuckMoveCycle():void{
        //Override
    }

    public stopDuckAnimation():void {
        this._moveDucksTL.pause();
        this._moveDucksTL.kill();
    }

    public reset():void {
        for(let i:number = 0; i < this._ducks.length; i++) {
            this._ducksContainer.removeChild(this._ducks[i]);
            this.doDuckReset(this._ducks[i]);
        }
        this._ducksContainer.position.x = 0;
        this._ducks = [];
        for (let i:number=0;i<this._bulletHoles.length;i++){
            this._bulletHoles[i].visible = false;
        }
    }

    protected doDuckReset(duck:LonerDuckSymbol):void {
        if(duck.symbolName == "MX1") {
            (<LonerDuckMX1Symbol>duck).reset();
        } else if(duck.symbolName == "MX2") {
            (<LonerDuckMX2Symbol>duck).reset();
        } else if(duck.symbolName == "MAX") {
            (<LonerDuckMaxWinSymbol>duck).reset();
        } else if(duck.symbolName == "CLIP") {
            (<LonerDuckClipSymbol>duck).reset();
        } else {
            duck.reset();
        }
    }

    public getAnimationTimeLeft():number {
        return MathHelper.floorToDecimals((this._moveDucksTL.totalDuration() - this._moveDucksTL.totalProgress()), 2);
    }

    get direction():string {
        return this._direction;
    }

    get ducks():LonerDuckSymbol[] {
        return this._ducks;
    }
}